import { useThemeValue } from "@gravity-ui/uikit";
import classNames from "classnames";
import { useMotionValue, motion, useMotionTemplate } from "framer-motion";
import React from "react";

import css from "./DotHighlightBackground.module.scss";

const dotThick = (fill: string) => {
  const encode = encodeSVG(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="18" height="18" fill="none"><circle fill="${fill}" id="pattern-circle" cx="10" cy="10" r="2.5"></circle></svg>`,
  );

  return `data:image/svg+xml,${encode}`;
};

export const DotHighlightBackground = ({
  children,
  className,
  containerClassName,
}: {
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
}) => {
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);

  const theme = useThemeValue();

  const handleMouseMove = ({
    currentTarget,
    clientX,
    clientY,
  }: React.MouseEvent<HTMLDivElement>) => {
    if (!currentTarget) return;
    const { left, top } = currentTarget.getBoundingClientRect();

    mouseX.set(clientX - left);
    mouseY.set(clientY - top);
  };
  return (
    <div
      className={classNames(
        css.dotHighlightBackgroundContainer,
        containerClassName,
      )}
      onMouseMove={handleMouseMove}
    >
      <div
        className={css.highlightBlock}
        style={{
          backgroundImage: `url("${dotThick(theme === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.15)")}")`,
        }}
      />
      <motion.div
        className={css.highlightMask}
        style={{
          WebkitMaskImage: useMotionTemplate`
            radial-gradient(
              200px circle at ${mouseX}px ${mouseY}px,
              black 0%,
              transparent 100%
            )
          `,
          maskImage: useMotionTemplate`
            radial-gradient(
              200px circle at ${mouseX}px ${mouseY}px,
              black 0%,
              transparent 100%
            )
          `,
          backgroundImage: `url("${dotThick(theme === "dark" ? "rgb(255, 190, 92)" : "rgb(233, 174, 86)")}")`,
        }}
      />

      <div
        className={classNames(className)}
        style={{ position: "relative", zIndex: 20 }}
      >
        {children}
      </div>
    </div>
  );
};

const encodeSVG = (data: string, externalQuotesDouble: boolean = false) => {
  const symbols = /[\r\n%#()<>?[\\\]^`{|}]/g;

  if (!externalQuotesDouble) {
    data = data.replace(/"/g, `'`);
  } else {
    data = data.replace(/'/g, `"`);
  }

  data = data.replace(/>\s{1,}</g, `><`);
  data = data.replace(/\s{2,}/g, ` `);

  return data.replace(symbols, encodeURIComponent);
};
